function Banner() {
  return (
    <div id='top' className="banner justify-center items-center -mt-16">
      <div className="text-grey">
        <h1 className="mb-5 text-4xl md:text-7xl">Hi, I'm Helen</h1>
        <p className="text-center text-xl md:text-3xl">Web Developer</p>
      </div>
    </div>
  )
}

export default Banner
